require("../sass/components/circle.sass");

class Circle {
	constructor(config){
		this.$el = config.el;

		if (config.text !== undefined) {
			this.text = config.text;
		} else {
			this.text = gettext('complete');
		}

		var currentPercentage = 0;
		var finalPercentage = config.percentage;

		this.overlay = $("<div class='overlay'/>");
		this.$el.append(this.overlay);

		this.overlayPercent = $("<h4 class='m-0'/>", {text: this.percentage+"%"});
		this.overlay.append(this.overlayPercent);

		this.overlayLabel = $("<small/>", {text: this.text});
		this.overlay.append(this.overlayLabel);

		this.percentClass = "progress-0";

		this.render(finalPercentage);

		// Cant do this animation because the row is a string instead of a jquery obj

		// this.render(0.0);
        //
		// var counter = setInterval(()=>{
		// 	console.log(currentPercentage)
		// 	this.render(currentPercentage++);
		// 	if (currentPercentage > finalPercentage){
		// 		clearInterval(counter);
		// 	}
		// }, 10);
	}
	render(new_percentage) {
		this.percentage = new_percentage;

		this.$el.removeClass(this.percentClass);
		this.percentClass = `progress-${this.percentage}`;

		this.$el.addClass(this.percentClass);
		this.overlayPercent.text(this.percentage+"%")

	}
}

module.exports = {
	Circle: Circle
}
